import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ManageRequestState {
  selectedRequest: string;
  actionComponent: React.ReactNode;
}

const initialState: ManageRequestState = {
  selectedRequest: '',
  actionComponent: null,
};

const manageRequestSlice = createSlice({
  name: 'manageRequestRequest',
  initialState,
  reducers: {
    setSelectedRequest: (
      state: ManageRequestState,
      action: PayloadAction<string | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.selectedRequest = '';
      } else {
        state.selectedRequest = payload;
      }
    },
    setActionComponent: (
      state: ManageRequestState,
      action: PayloadAction<React.ReactNode>
    ) => {
      const { payload } = action;

      state.actionComponent = payload;
    },
  },
});

const { actions } = manageRequestSlice;

export const manageRequestActions = {
  ...actions,
};

export default manageRequestSlice;
